export default {
  curatorMetadata: {
    roadmapHeaders: {
      employee: 'Employee',
      goalType: 'Development goal type',
      status: 'Development plan status',
      deadline: 'Deadline',
      author: 'Plan author',
      myRole: 'My role in the plan',
    },
    roadmapFilters: {
      status: 'Development plan status',
      myRole: 'My role in the plan',
    },
    userHeaders: {
      name: "Employee's full name",
      employeeAvg: 'Average employee score',
      curatorAvg: 'Average </br> supervisor/curator score',
      curatorAvgMobile: 'Average supervisor/curator score',
      efficiency: 'Efficiency',
    },
    adaptationHeaders: {
      planName: 'Name of the plan',
      teamName: 'Name of the team',
      dateStart: 'Start date',
      progress: 'Progress',
      statistics: 'Statistics',
    },
    exportFileName: 'Results_to_the_targets_of_the_curated_employees',
    targetHeaders: {
      name: 'Name',
      importance: 'Importance',
      status: 'Status',
      employeeScore: 'Employee score',
      curatorScore: 'Supervisor/Curator score',
      curatorScoreMobile: 'Supervisor/Curator score',
      type: 'Type',
      progress: 'Progress',
      deadline: 'Deadline',
    },
    // confirm dialogs
    confirmArchiveTargets: {
      title: 'Moving the targets to the archive',
      button: 'Yes, move',
      text: 'Do you really want to archive this targets? Archived targets will not be involved in calculating efficiency and average scores.',
    },
    confirmUnarchiveTargets: {
      title: 'Moving the targets from the archive to the current list',
      button: 'Yes, move',
      text: 'Do you really want to move your goals to the current list?',
    },
    confirmMoveTargets: {
      title: 'Change the status of targets?',
      button: 'Yes, change',
      text: 'The status of the selected targets will be changed to: «{status}»',
    },
    exportTargets: 'Export all the results for all curated employees to excel',
    efficiency: 'Percentage of completed targets out of agreed ones',
    scoreAvg:
      'The average score is calculated as the arithmetic weighted average of all target scores: the sum of targets multiplied by their weights divided by the sum of all weights. The weight of the target is determined automatically depending on the set importance.',
    // messages
    successMessages: {
      archiveTargets: 'The targets successfully moved to the archive',
      unarchiveTargets: 'The targets successfully moved to the current list',
      moveTarget: 'The status of the target «{targetName}» successfully changed',
    },
    errorMessages: {
      archiveTargets: 'Failed to move the targets to the archive',
      unarchiveTargets: 'Failed to move the targets to the current list',
      moveTarget: 'Failed to change the status of the target «{targetName}»',
      exportTargets: 'Failed to export the results',
      getCuratedRoadmaps: 'Failed to get supervised development plans',
    },
    noRoadmaps: 'You do not have any supervised development plans yet.',
    noAdaptations: "You don't have any curated adaptations yet.",
    noTargets: 'You do not have any curated targets yet.',
    noArchivalTargets: 'You do not have any archival targets yet.',
  },
};
